import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { OTP_LOGIN_PAYLOAD, SESSION_STORAGE_KEYS } from 'src/app/shared/types/types';
import { SharedService } from 'src/app/shared/services/other/shared.service';
import { ToastService } from 'src/app/shared/services/other/toaster.service';
import { SamhitaOndcWoCService } from 'src/app/shared/services/api/samhita-ondc-wo-c.service';
import { AuthService } from 'src/app/shared/services/api/auth.service';
import { OTP_LOGIN } from 'src/app/shared/texts/texts';
import { TranslatorService } from 'src/app/shared/services/other/translator.service';

@Component({
  selector: 'app-mobile-otp',
  templateUrl: './mobile-otp.component.html',
  styleUrls: ['./mobile-otp.component.scss']
})
export class MobileOtpComponent implements OnInit {

  otpLoginContent = OTP_LOGIN
  otpForm = this.formBuilder.group({
    phone: ['', [Validators.required,]],
    code: ['', [Validators.minLength(6), Validators.maxLength(6)]],
  });

  get activeLan(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.CURRENT_LANGUAGE)
  }

  get targetLan(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TARGET_LANGUAGE)
  }

  constructor(
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private authService: AuthService,
    private samhitaOndcWoCService: SamhitaOndcWoCService,
    private translateService : TranslatorService
  ) { }

  ngOnInit(): void {
    this.clearSession();
    this.translateService.lanUpdates.subscribe((res)=>{
      if(res){
        this.otpLoginContent = OTP_LOGIN
        if(res!=='en') this.translateStaticContents()
      }
    })

     if(this.activeLan && this.targetLan) this.translateStaticContents()
  }

  clearSession() {
    this.sharedService.removeDataToSessionStorage(SESSION_STORAGE_KEYS.SESSION_TOKEN);
    this.sharedService.removeDataToSessionStorage(SESSION_STORAGE_KEYS.USER_INFO);
  }

  countdown = 30;
  otpSent: boolean = false;
  private countdownSubscription!: Subscription;
  canResendOtp: boolean = true;

  startCountdown() {
    this.countdown = 30;
    this.canResendOtp = false;

    this.countdownSubscription = interval(1000).subscribe(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.canResendOtp = true;
        this.countdownSubscription.unsubscribe();
      }
    });
  }

  onOtpSubmit() {
    if (!this.otpSent) {
      this.sendVerifyOtp('send');
    } else {
      this.sendVerifyOtp('verify');
    }
  }
  sendVerifyOtp(type: 'send' | 'verify') {
    const userName = this.otpForm.get('phone')?.value;

    if (!userName) {
      this.toastService.presentToast('Phone number / Email is required', 'warning');
      return;
    }

    const isEmail = userName.includes('@');
    const isPhoneNumber = userName.length === 10 && !userName.includes('@');

    if (!isEmail && !isPhoneNumber) {
      this.toastService.presentToast('Invalid phone number / Email format', 'warning');
      return;
    }

    const payload: OTP_LOGIN_PAYLOAD = {
      phone: isPhoneNumber ? userName : null,
      email: isEmail ? userName : null,
      code: this.otpForm.get('code')?.value || null
    };

    isEmail ? delete payload.phone : delete payload.email;


    if (type === 'send') {
      this.sendOTP(payload);
    } else if (type === 'verify') {
      this.verifyOTP(payload);
    }



  }

  sendOTP(payload: OTP_LOGIN_PAYLOAD) {
    delete payload.code;
    this.samhitaOndcWoCService.requestOTP(payload).subscribe(
      (response: any) => {
        this.handleOtpResponse(response, 'send');
      }
    );
  }

  verifyOTP(payload: OTP_LOGIN_PAYLOAD) {
    if (!payload.code || payload.code.length !== 6) {
      this.toastService.presentToast('Please enter OTP', 'warning');
      return;
    }
    this.samhitaOndcWoCService.OTPLogin(payload).subscribe(
      (response: any) => {
        this.handleOtpResponse(response, 'verify');
      }
    );
  }

  private handleOtpResponse(response: any, type: 'send' | 'verify') {
    if (type === 'send') {
      this.otpSent = true;
      this.startCountdown();
    } else if (type === 'verify') {
      this.authService.createSession(response)
    }
  }

  onPhoneInput(event: any) {
    this.otpForm.get('code')?.reset()
    if (event.target.value.length !== 10 && !event.target.value.includes('@')) {
      this.countdown = 30;
      this.canResendOtp = false;
      this.countdownSubscription?.unsubscribe();
      this.otpSent = false
    }
  }

  async translateStaticContents(){
    const updatedStaticContent = await this.translateService.translateSection(this.otpLoginContent) as string[];

    if(updatedStaticContent) this.otpLoginContent = updatedStaticContent
  
  }

}
